import { LocalShipping } from "@mui/icons-material";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { Box, Tooltip } from "@mui/material";
import React, { useContext } from "react";

import ClearAllUnreads from "@/components/ClearAllUnreads.tsx";
import UseContextMenu from "@/components/ContextMenus/UseContextMenu.tsx";
import { useGlobalFlags } from "@/hooks/useGlobalFlags";
import { WorkspaceContext } from "@/models/StateProviders/workspaceProvider.tsx";
import { TrackingContext } from "@/models/TrackingStateProvider.tsx";
import { UxContext } from "@/models/UxStateProvider.tsx";

export default function ChannelTypes({
  activeChannelType,
  changeChannelType,
  unreadCount,
  limitedMember,
  workspaceMembershipId,
  tempOverRide,
}: {
  activeChannelType: string;
  changeChannelType: (value: string) => void;
  unreadCount: number;
  limitedMember: boolean;
  workspaceMembershipId: string;
  tempOverRide?: string;
}) {
  const { clearAllUnread } = useGlobalFlags();
  const { currentWorkspaceId } = useContext(WorkspaceContext);
  const { ampli } = useContext(TrackingContext);
  const { setFleetMessageModalOpen, hideDriverMessages } = useContext(UxContext);

  const showContextMenu = clearAllUnread && !hideDriverMessages && unreadCount > 0;

  const types = [
    {
      text: "My Channels",
      key: "my-channels",
      toolTip: "You have subscribed to notifications for these channels",
      indicator: false,
      hideLimitedMember: false,
      disabled: false,
      icon: <NotificationsActiveIcon sx={{ fontSize: "16px" }} />,
      contextMenu: false,
    },
    {
      text: "My Unreads",
      key: "my-unreads",
      toolTip: null,
      indicator: true,
      hideLimitedMember: false,
      disabled: false,
      icon: null,
      contextMenu: true,
    },
    {
      text: "All Channels",
      key: "all-channels",
      toolTip: null,
      indicator: false,
      hideLimitedMember: true,
      disabled: false,
      icon: null,
      contextMenu: false,
    },
    {
      text: "All Unreads",
      key: "all-unreads",
      toolTip: null,
      indicator: false,
      hideLimitedMember: true,
      disabled: true,
      icon: null,
      contextMenu: false,
    },
  ]
    .filter((type) => {
      if (limitedMember || type.disabled) {
        return !type.hideLimitedMember;
      }
      return true;
    })
    .map((type) => ({
      ...type,
      active: type.key === (tempOverRide || activeChannelType),
    }));

  const buttonStyle = {
    width: "100%",
    textAlign: "center",
    display: "flex",
    gap: 1,
    alignItems: "center",
    justifyContent: "center",
    color: "#ccc",
    py: 1,
    px: 2,
    fontSize: "1rem",
    "&.active": { background: "#747579", color: "#fff" },
    "&:hover": { color: "#fff" },
  };
  const showFleetMessageButton = true;
  const openFleetMessageModal = () => {
    setFleetMessageModalOpen(true);
    ampli.openFleetMessage({ workspaceId: currentWorkspaceId });
  };

  const { handleContextMenu, handleClose, contextMenuItem, contextMenu } = UseContextMenu();

  return (
    <Box className="channel-types-container" sx={{ display: "flex" }}>
      <Box
        sx={{ flexGrow: 1, gap: 0.5, background: "#404449", padding: "3px", borderRadius: "0.25rem", display: "flex" }}
      >
        {types.map((type) => (
          <Tooltip title={type.toolTip} key={type.key}>
            <>
              <Box
                onClick={(e) => {
                  if (contextMenu) {
                    e.preventDefault();
                    return;
                  }
                  changeChannelType(type.key);
                }}
                component="button"
                type="button"
                className={`basic-button  ${type.active ? "active-channel-type" : ""}`}
                sx={{ ...buttonStyle }}
                onContextMenu={type.contextMenu && showContextMenu ? handleContextMenu : () => {}}
              >
                {type?.icon && (
                  <span style={{ display: "flex" }} className="icon">
                    {type.icon}
                  </span>
                )}
                <span className="text">{type.text}</span>
                {type.indicator && unreadCount > 0 && (
                  <span className={`indicator ${unreadCount > 0 ? "active" : "in-active"}`} />
                )}
              </Box>
              {type.contextMenu && showContextMenu
                ? contextMenuItem(
                    <ClearAllUnreads
                      workspaceMembershipId={workspaceMembershipId}
                      closeContext={() => handleClose()}
                    />,
                  )
                : null}
            </>
          </Tooltip>
        ))}
      </Box>
      {showFleetMessageButton && (
        <Box sx={{ display: "flex", alignItems: "center", pl: 1 }}>
          <Box
            onClick={() => openFleetMessageModal()}
            type="button"
            component="button"
            className="basic-button button-purple"
            sx={{ ...buttonStyle, px: 1 }}
          >
            <LocalShipping sx={{ fontSize: "18px" }} />
            <span>Fleet Message</span>
          </Box>
        </Box>
      )}
    </Box>
  );
}
